import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ReadOnlyProperty } from '../../../shared/ui/control-options/control-option.interface';
import { HttpErrorResponse } from '@angular/common/http';
import { INotificationService } from '../../../shared/services/inotification.service';
import { OrganizationSelect } from '../../../shared/ui/select-controls/organizations-select.model';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { ItemBundle } from '../../../shared/interfaces/entities/item-bundle.interface';
import { ItemSelect } from '../../../shared/ui/select-controls/item-select.model';
import { ItemFilter } from '../../../shared/interfaces/select-filters/item-filter.interface';
import { AuthenticationService } from '../../../core/services/authentication.serivce';

@Component({
    selector: 'app-item-bundle',
    templateUrl: './item-bundle.component.html',
    styleUrls: ['./item-bundle.component.css'],
    standalone: false
})
export class ItemBundleComponent implements OnInit {

  @Input() entity: ItemBundle;
  @Output() submitForm: EventEmitter<FormGroup> = new EventEmitter();

  itemSelect: ItemSelect;

  saveIcon = faSave;
  saving: boolean = false;

  constructor(private fb: FormBuilder,
              private notificationService:INotificationService,
              private auth: AuthenticationService,) { }

  public form: FormGroup;

  ngOnInit(): void {
    var isNew: boolean = this.entity == undefined || this.entity == null || this.entity.id == undefined || this.entity.id == 0;

    var itemValue = { id: this.entity.itemId, name: this.entity.item_Name }
    this.itemSelect = new ItemSelect("itemId", "SKU", itemValue);

    var itemFilters: ItemFilter = {
      organizationId: this.auth.getOrganizationId(),
      bundleId: this.entity.parentEntityId
    };
    this.itemSelect.filters = itemFilters;

    if (!isNew) {

      this.itemSelect.addOption(new ReadOnlyProperty());
      // Get the other options that can be selected

      var obj = {
        value: { id: this.entity.itemId }
      };
    } else {
      this.entity.id = 0;
      var bundleId = Number(window.location.pathname.split('/').at(-1));
      this.entity.bundleId = bundleId;
    }

    this.form = this.fb.group({
      id: [this.entity.id],
      item_Name: [this.entity.item_Name],
      itemId: [this.entity.itemId],
      bundleId: [this.entity.bundleId],
      quantity: [this.entity.quantity, Validators.required]
    });
  }

  save() {
    var itemId = this.itemSelect.getValue();

    if (itemId == undefined || itemId == null || itemId.length == 0) {
      var l = document.getElementById(this.itemSelect.id);
      if (l) {
        l.style.border = "2px solid orangered";
      }
      return;
    } else {
      this.saving = true;

      this.form.controls['itemId'].setValue(itemId);

      this.submitForm.emit(this.form);
    }
  }
}
